import React, { useMemo } from 'react'
import { css } from '@emotion/core'
import { ButtonType } from '@/components/atoms/button'
import { FrontTabletButton } from './button'
import { useVisualViewport } from '@/hooks/use-visual-viewport'
import { createSelfCheckinBaseStyle, createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'

const FOOTER_HEIGHT = 96

export type FooterProps = {
  left?: {
    isDisabled?: boolean
    label: string
    onClick: () => void
  }
  right?: {
    isDisabled?: boolean
    label: string
    onClick: () => void
  }
}

export const Footer: React.FC<FooterProps> = props => {
  const { visualViewport } = useVisualViewport()

  const topPosition = useMemo(() => {
    const visualHeight = visualViewport.offsetTop + visualViewport.height
    return visualHeight - FOOTER_HEIGHT
  }, [visualViewport.height, visualViewport.offsetTop])

  return (
    <div
      css={componentStyle}
      style={{
        justifyContent: props.left && props.right ? 'space-between' : props.right ? 'flex-end' : 'flex-start',
        top: topPosition,
      }}
    >
      {props.left && (
        <FrontTabletButton
          isDisabled={props.left.isDisabled}
          buttonType={props.left.isDisabled ? ButtonType.SecondaryDisabled : ButtonType.Secondary}
          onClick={props.left.onClick}
          customCss={selfCheckinFooterButtonStyle}
        >
          {props.left.label}
        </FrontTabletButton>
      )}
      {props.right && (
        <FrontTabletButton
          isDisabled={props.right.isDisabled}
          buttonType={props.right.isDisabled ? ButtonType.PrimaryDisabled : ButtonType.Primary}
          onClick={props.right.onClick}
          customCss={selfCheckinFooterButtonStyle}
        >
          {props.right.label}
        </FrontTabletButton>
      )}
    </div>
  )
}

const selfCheckinFooterButtonStyle = css(
  { pointerEvents: 'auto' },
  createSelfCheckinResponsiveStyle({
    landscape11: {
      width: 160,
      height: 60,
      fontSize: 22,
    },
    portrait: {
      width: 160,
      height: 60,
      fontSize: 22,
    },
    landscape13: {
      width: 200,
      height: 80,
      fontSize: 32,
      borderRadius: 40,
    },
  }),
)

const componentStyle = css(
  {
    position: 'fixed',
    zIndex: 2,
    height: FOOTER_HEIGHT,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '0 40px',
    pointerEvents: 'none',
  },
  createSelfCheckinBaseStyle({ transform: 'translateY(-22px)' }),
  createSelfCheckinResponsiveStyle({ portrait: { padding: '0 24px' } }),
)
